mutation SetAircallIntegrationIsEnabledForInstance($isEnabled: Boolean!) {
    setAircallIntegrationIsEnabledForInstance(input: {isEnabled: $isEnabled}) {
        authUrl
    }
}
